import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Students from '../views/Student/Students.vue'
import Permissions from '../views/Student/Permissions.vue'
import Roles from '../views/Student/Roles.vue'
import Log from '../views/Student/Log.vue'
import Plcsdata from '@/views/Student/Plcsdata.vue'
import Router from 'vue-router'
//
//
Vue.use(Router)
// const router = new VueRouter({
//     mode: 'history',
//     routes: [
//         {
//             path: '/',
//             redirect: '/home'
//         },
//         //
//         {
//             path: '/login',
//             name: 'login',
//             component: Login,
//             meta: { title: '登录' },
//         },
//         //
//         {
//             path: '/home',
//             name: 'home',
//             redirect: '/students',
//             component: Home,
//             meta: { title: '首页' },
//             children: 
//             [{
//                 path: '/students',
//                 name: 'students',
//                 component: Students,
//                 meta: { title: '学生列表' },
//             },            
//             {
//                 path: '/PLCdata',
//                 name: 'plcdata',
//                 component: Plcsdata,
//                 meta: { title: 'plc数据' }
//             }, 
//             {
//                 path: '/permissions',
//                 name: 'permissions',
//                 component: Permissions,
//                 meta: { title: '权限列表aaa' },
//             }, {
//                 path: '/roles',
//                 name: 'roles',
//                 component: Roles,
//                 meta: { title: '角色列表aaa' },
//             }, {
//                 path: '/log',
//                 name: 'log',
//                 component: Log,
//                 meta: { title: '管理员日志' },
//             }]
//         },
//     ]
// }) 
export const constantRoutes = [
        {
            path: '/',
            redirect: '/home'
        },
        //
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: { title: '登录' },
        },
        //
        {
            path: '/home',
            name: 'home',
            redirect: '/PLCdata',
            component: Home,
            meta: { title: '首页' },
            children: 
            [{
                path: '/students',
                name: 'students',
                component: Students,
                meta: { title: '学生列表' },
            },            
            {
                path: '/PLCdata',
                name: 'plcdata',
                component: Plcsdata,
                meta: { title: 'plc数据sdf' }
            }, 
            {
                path: '/permissions',
                name: 'permissions',
                component: Permissions,
                meta: { title: '权限列表aaa' },
            }, {
                path: '/roles',
                name: 'roles',
                component: Roles,
                meta: { title: '角色列表aaa' },
            }, {
                path: '/log',
                name: 'log',
                component: Log,
                meta: { title: '管理员日志' },
            }]
        }
    ]
    //
    const createRouter = ()=>new VueRouter({
        scrollBehavior:()=>({y:0}),
        routes:constantRoutes
    })
    const router = createRouter()
    //
    export function resetRouter(){
        const newRouter = createRouter()
        router.matcher= newRouter.matcher  //reset router
    }
export default router
